// Canvas marketplace page — mounts the real `MarketplaceIsland`, the same
// self-contained unit the standalone `marketplace.localhost` app
// (marketplace/pages/main.js) and the public `symbols.app/marketplace`
// landing pages (company/packages/landing + no-code-landing) mount, wrapped
// in the same AppSidebar + AppMain chrome as /dashboard so the layout stays
// consistent across canvas routes.
//
// WS-APPS ticket (tickets/workspace.md "marketplace canvas fork drift"):
// this page used to hand-fork Island's composition — its own state shape
// (missing signinModal/_signedIn/_installScopeOpen/gallery+template-view
// state, missing live-catalog + installed/sort/recent/density/pinned
// localStorage hydration) and its own legacy MarketplaceGrid +
// MarketplaceDetail side-panel layout instead of Island's per-kind section
// grid + MarketplaceDetailModal overlay — so every new kind/section
// (Templates/Libraries/Integrations/Prompts/Agents/Skills, the Workspace
// Apps headline rail, the "Featured today" strip, …) had to be added
// twice. Island already sets its own `_marketplaceHost: true` and owns its
// full state + hydration + URL-sync + Esc-handling internally (see
// MarketplaceIsland.js's own doc comment + `onCreate`/`onUpdate`), so
// mounting it bare here satisfies its state contract with zero extra wiring
// — exactly the pattern `marketplace/pages/main.js` and the landing
// `/marketplace` pages already use. One edit (Island) now reaches every
// surface, canvas included.
//
// Deep-link filters (`?kind=…&categories=…&q=…&sort=…&pricing=…&item=…`)
// keep working via Island's own `hydrateFiltersFromLocation` +
// `bindPopstateFilters` + `writeFiltersToUrl` (marketplace/functions/index.js)
// — all three read/write `window.location` directly, so they behave
// identically whether canvas's pushState patch fired or not (this page no
// longer needs its own `currentSearch`-reading fork of that logic).

export const marketplace = {
  tag: 'main',
  id: 'main-content',
  extends: 'AppPage',
  metadata: (el) => ({ title: el.call('polyglot', 'canvas.page.marketplace.title') }),
  // Single `1fr` shell row — `gridRow: '1'` fills the content track; the legacy
  // `'2'` strands the page in an implicit 0-height row 2. See main.js.
  gridRow: '1',
  gridColumn: '1 / -1',
  minHeight: '0',
  height: '100%',
  overflow: 'hidden',
  color: 'title',

  // Marketplace sidebar removed — its kind / pinned / recent groups live
  // in Island's own top filter row (MarketplaceFilters).
  AppSidebar: null,

  AppMain: {
    padding: '0',
    overflow: 'hidden',
    minHeight: '0',

    Body: {
      padding: '0',
      overflow: 'hidden',

      // Bare mount — Island supplies its own state defaults, sizing
      // (flex:'1', width/height:'100%', minHeight:'0', overflowY:'auto')
      // and `_marketplaceHost: true` flag, so `marketplaceHostOf` binds
      // every marketplace component to the Island, not canvas's app root.
      MarketplaceIsland: {}
    }
  }
}
